import { Handle, Position } from "reactflow"
import { CustomNodeProperties } from "../types/types"

// import './nodo-etapa.styles.css'
import { Box, Typography } from "@mui/material"

const NodoEtapa = (props: CustomNodeProperties) => {

    return (
        <>
            {/* {
                [...Array(props.data.n_entradas)].map((_, i) => {
                    return (
                        <Handle
                            key={i}
                            type='target'
                            id={i.toString()}
                            position={Position.Left}
                            style={{ top: `${(i + 1) * 100 / (props.data.n_entradas + 1)}%` }}
                        />
                    )
                })
            } */}
            <Handle
                type='target'
                position={Position.Left}
            />
            <div className="nodo-etapa"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                }}
            >
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <Typography
                        style={{ fontSize: '12px' }}
                        align={'center'}
                    >
                        {props.data.label}
                    </Typography>
                </Box>
            </div>
            <Handle
                type='source'
                position={Position.Right}
            />
            {/* {
                [...Array(props.data.n_salidas)].map((_, i) => {
                    return (
                        <Handle
                            key={i}
                            type='source'
                            id={i.toString()}
                            position={Position.Right}
                            style={{ top: `${(i + 1) * 100 / (props.data.n_salidas + 1)}%` }}
                        />
                    )
                })
            } */}
        </>
    )
}

export default NodoEtapa
